<template lang="pug">
  v-layout.ld-tile(:class="{ 'is-active': isActive, 'disabled': disabled }" align-center justify-center)
    //- The content of the layout, which could be changed and customized
    slot(name="content")
      v-layout(align-center justify-center column)
        v-tooltip(bottom)
          v-icon(
            v-if="!!warning"
            data-cy="action-type-warning-icon"
            slot="activator"
            color="primary"
            small
            right
          ) warning
          span {{ warning }}
        v-icon(v-if="icon")
          | {{ icon }}

        div.subheader(v-if="textContent")
          | {{ textContent }}
</template>
<script>
export default {
  props: {
    warning: {
      type: String,
      default: null,
    },
    // Whether the current tile is disabled and clickable
    disabled: Boolean,
    // The content of the card to be displayed
    textContent: String,
    // The icon to be displayed if present
    icon: String,
    // Indicates that a current tile is active by giving it the 'is-active' class.
    isActive: Boolean,
  },
};
</script>
<style lang="scss">
// Aruably this could be in the 'liondesk.scss' file, but in light of encapsulation,
// it might be better to write this here so that this component be modular
  .ld-tile {
    cursor: pointer;
    height: 150px;
    width: 150px;
    color: var(--v-primary-base);
    position: relative;
    .v-tooltip {
      position: absolute;
      top: 10px;
      right: 20px;
    }
    > div > i {
      font-size: 60px;
      color: var(--v-primary-base) !important;
      padding-bottom: 10px;
    }
  }
  .is-active {
    box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
  }
  .disabled {
    cursor: default;
    opacity: 0.4;
  }
</style>
